import React, {useState} from "react";
import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import StateViewController from "../../vc/StateViewController";
import {getManager} from "../../../ts/manager/Manager";
import {PostStatus, PostType} from "../../../ts/manager/post/PostManager";
import {assert} from "../../../ts/common/Assert";
import PostListView from "./partial/PostListView";
import RouteChoiceButton from "../../element/button/RouteChoiceButton";

const PostListPage = (props:IRouteProps) =>
{
    const postType:PostType = getManager().navigation.model.routeIDs.post_type ?? "organisation";
    const myEdit = getManager().navigation.model.routeIDs.browse_route_id === "my_profile";
    const routeModel = getModelFactory().postListRoute.getDefaultModel(postType, myEdit);
    const addRouteChoice =  myEdit ? (getModelFactory().postRoute.getDefaultModel(postType)?.choices.add ?? null) : null;
    const postConfig = postType ? (getManager().post.config[postType] ?? null) : null;
    const [validPostStatuses] = useState<PostStatus[]|null>(myEdit ? ["pending", "publish", "draft", "expired"] : null);

    const requestDataModel = routeModel?.postDataModel ?? null;
    const displayDataModel = routeModel?.sourceDataModel ?? null;

    const viewState = StateViewController({
        routeProps: props,
        dataModels: requestDataModel,
        assert: [requestDataModel, displayDataModel]
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }
    assert(routeModel);
    assert(displayDataModel);


    return <>
        {!!addRouteChoice && <>
            <section className="content-block pb-0">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-end">

                            <RouteChoiceButton
                                routeChoice={addRouteChoice}
                                label={"Submit "+(postConfig?.aName ?? "")}
                                className={"btn reduced"}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>}
        <PostListView
            routeProps={props}
            postType={postType}
            routeChoiceList={routeModel?.choiceList() ?? []}
            postModel={displayDataModel}
            hideMap={myEdit}
            hideCounties={myEdit}
            validPostStatuses={validPostStatuses}
            allowInvalid={myEdit}
        />
    </>
}

export default PostListPage;